import React from 'react';
import {
	SkeletonBrand,
	SkeletonCard,
	SkeletonImg,
	SkeletonPrice,
	SkeletonTitle,
} from './styled-skeleton-card';

function SkeletonCardComponent() {
	return (
		<SkeletonCard>
			<SkeletonImg />
			<SkeletonBrand />
			<SkeletonTitle />
			<SkeletonPrice />
		</SkeletonCard>
	);
}

export default SkeletonCardComponent;
